export default __webpack_public_path__ + "static/media/commission_icon.2287e15c.svg";